module.exports = __webpack_public_path__ + "img/report-icon.ef8fc72c.svg";